import { useMutation } from '@tanstack/react-query'
import { updateAccountApprovalsPreference } from 'services/ApprovalsService'
import { GovernanceApprovalSettings } from 'types/approvals'
import { BaseErrorResponse } from 'types/beneficiaries'
import { logSentryError } from 'utils/sentry'

export const useAccountApprovalsPreferenceMutation = () => {
  return useMutation({
    mutationFn: ({ data }: { data: GovernanceApprovalSettings }) =>
      updateAccountApprovalsPreference(data),
    onError: (error: BaseErrorResponse) => {
      logSentryError(
        'Error from useAccountApprovalsPreferenceMutation - updateAccountApprovalsPreference',
        error
      )
    },
  })
}
